/*
 * Created by David Adams
 * https://codeshack.io/dynamic-select-images-html-javascript/
 *
 * Released under the MIT license
 */

class DynamicSelect {

    constructor(element, options = {}) {
        let defaults = {
            placeholder: 'Selecciona un país',
            columns: 1,
            name: '',
            width: '',
            height: '',
            data: [],
            onChange: function(value) {
                if (value) {
                    window.open(value, '_blank');
                }
            }
        };
        this.options = Object.assign(defaults, options);
        this.selectElement = typeof element === 'string' ? document.querySelector(element) : element;
        for(const prop in this.selectElement.dataset) {
            if (this.options[prop] !== undefined) {
                this.options[prop] = this.selectElement.dataset[prop];
            }
        }
        this.name = this.selectElement.getAttribute('name') ? this.selectElement.getAttribute('name') : 'dynamic-select-' + Math.floor(Math.random() * 1000000);
        if (!this.options.data.length) {
            let options = this.selectElement.querySelectorAll('option');
            // Store the initial selected option's value and innerHTML
            this.initialSelectedValue = '';
            this.initialSelectedHTML = ''; // To store the full HTML content of the selected option
            for (let i = 0; i < options.length; i++) {
                const optionData = {
                    value: options[i].value,
                    text: options[i].innerHTML,
                    img: options[i].getAttribute('data-img'),
                    selected: options[i].selected,
                    html: options[i].getAttribute('data-html'),
                    imgWidth: options[i].getAttribute('data-img-width'),
                    imgHeight: options[i].getAttribute('data-img-height')
                };
                this.options.data.push(optionData);

                // If this option is initially selected, store its details
                if (options[i].selected) {
                    this.initialSelectedValue = options[i].value;
                    // Reconstruct the HTML for the header if it's not custom HTML
                    if (optionData.html) {
                        this.initialSelectedHTML = optionData.html;
                    } else {
                        let imgTag = optionData.img ? `<img src="${optionData.img}" alt="${optionData.text}" class="${optionData.imgWidth && optionData.imgHeight ? 'dynamic-size' : ''}" style="${optionData.imgWidth ? 'width:' + optionData.imgWidth + ';' : ''}${optionData.imgHeight ? 'height:' + optionData.imgHeight + ';' : ''}">` : '';
                        let textSpan = optionData.text ? '<span class="dynamic-select-option-text link-faded">' + optionData.text + '</span>' : '';
                        this.initialSelectedHTML = `${imgTag}${textSpan}`;
                    }
                }
            }
        }
        this.element = this._template();
        this.selectElement.replaceWith(this.element);
        this._updateSelected();
        this._eventHandlers();
    }

    _template() {
        let optionsHTML = '';
        for (let i = 0; i < this.data.length; i++) {
            // Ocultar la primera opción del desplegable si es la opción inicial seleccionada
            // Es decir, si el valor de la opción actual coincide con el valor inicial seleccionado
            // Y no es la primera opción, o si lo es, pero queremos que no aparezca en la lista
            // Aquí, vamos a mostrar todas las opciones en el _template para que DynamicSelect
            // las procese, y luego usaremos CSS para ocultar la que no queremos.
            // La lógica para que no aparezca en el desplegable se manejará principalmente en el CSS.
            // Sin embargo, para que el *plugin* no la marque como seleccionada en la lista si no debe estar,
            // y evitar que se seleccione la primera opción por accidente, podemos añadir una clase.
            let optionWidth = 100 / this.columns;
            let optionContent = '';
            if (this.data[i].html) {
                optionContent = this.data[i].html;
            } else {
                optionContent = `
                    ${this.data[i].img ? `<img src="${this.data[i].img}" alt="${this.data[i].text}" class="${this.data[i].imgWidth && this.data[i].imgHeight ? 'dynamic-size' : ''}" style="${this.data[i].imgWidth ? 'width:' + this.data[i].imgWidth + ';' : ''}${this.data[i].imgHeight ? 'height:' + this.data[i].imgHeight + ';' : ''}">` : ''}
                    ${this.data[i].text ? '<span class="dynamic-select-option-text link-faded">' + this.data[i].text + '</span>' : ''}
                `;
            }

            // Agrega una clase especial para el elemento original para que el CSS lo oculte
            const isOriginalCountry = this.data[i].value === this.initialSelectedValue;
            const extraClass = isOriginalCountry ? ' dynamic-select-original-option' : '';

            optionsHTML += `
                <div class="dynamic-select-option${this.data[i].value == this.selectedValue ? ' dynamic-select-selected' : ''}${this.data[i].text || this.data[i].html ? '' : ' dynamic-select-no-text'}${extraClass} link-faded" data-value="${this.data[i].value}" style="width:${optionWidth}%;${this.height ? 'height:' + this.height + ';' : ''}">
                    ${optionContent}
                </div>
            `;
        }
        let template = `
            <div class="dynamic-select ${this.name}"${this.selectElement.id ? ' id="' + this.selectElement.id + '"' : ''} style="${this.width ? 'width:' + this.width + ';' : ''}${this.height ? 'height:' + this.height + ';' : ''}">
                <input type="hidden" name="${this.name}" value="${this.selectedValue}">
                <div class="dynamic-select-header" style="${this.width ? 'width:' + this.width + ';' : ''}${this.height ? 'height:' + this.height + ';' : ''}"><span class="dynamic-select-header-placeholder">${this.placeholder}</span></div>
                <div class="dynamic-select-options" style="${this.options.dropdownWidth ? 'width:' + this.options.dropdownWidth + ';' : ''}${this.options.dropdownHeight ? 'height:' + this.options.dropdownHeight + ';' : ''}">${optionsHTML}</div>
            </div>
        `;
        let element = document.createElement('div');
        element.innerHTML = template;
        return element;
    }

    _eventHandlers() {
        this.element.querySelectorAll('.dynamic-select-option').forEach(option => {
            option.onclick = () => {
                const selectedValue = option.getAttribute('data-value');

                // Si se selecciona el país original, no hacer nada más que cerrar el desplegable
                if (selectedValue === this.initialSelectedValue) {
                    this.element.querySelector('.dynamic-select-header').classList.remove('dynamic-select-header-active');
                    // No hacemos nada con la redirección ni actualizamos el visual si es el mismo país
                    return;
                }

                // Si no es el país original, proceder con la redirección y luego restaurar el visual
                this.element.querySelectorAll('.dynamic-select-selected').forEach(selected => selected.classList.remove('dynamic-select-selected'));
                option.classList.add('dynamic-select-selected');
                
                // NO actualizamos el innerHTML del header aquí, lo restauraremos después
                // this.element.querySelector('.dynamic-select-header').innerHTML = option.innerHTML; 
                
                this.element.querySelector('input').value = selectedValue; // Actualiza el input hidden
                this.data.forEach(data => data.selected = false);
                this.data.filter(data => data.value == selectedValue)[0].selected = true;
                this.element.querySelector('.dynamic-select-header').classList.remove('dynamic-select-header-active');
                
                // Ejecuta el onChange, que ahora incluirá la redirección
                this.options.onChange(selectedValue, option.querySelector('.dynamic-select-option-text') ? option.querySelector('.dynamic-select-option-text').innerHTML : '', option);

                // Después de la redirección, restaura el header visualmente al país original
                const header = this.element.querySelector('.dynamic-select-header');
                if (header && this.initialSelectedHTML) {
                    header.innerHTML = this.initialSelectedHTML;
                    // También asegura que el input hidden vuelva a tener el valor del país original
                    this.element.querySelector('input').value = this.initialSelectedValue;

                    // Desmarca visualmente cualquier opción que haya sido "seleccionada" temporalmente en el menú
                    this.element.querySelectorAll('.dynamic-select-option.dynamic-select-selected').forEach(sel => {
                        sel.classList.remove('dynamic-select-selected');
                    });
                    // Marca la opción original como seleccionada internamente si es necesario para futuras interacciones
                    // Aunque si está oculta, el usuario no la verá marcada
                    const originalOptionDiv = this.element.querySelector(`.dynamic-select-option[data-value="${this.initialSelectedValue}"]`);
                    if (originalOptionDiv) {
                        originalOptionDiv.classList.add('dynamic-select-selected');
                    }
                }
            };
        });
        this.element.querySelector('.dynamic-select-header').onclick = () => {
            this.element.querySelector('.dynamic-select-header').classList.toggle('dynamic-select-header-active');
        };
        if (this.selectElement.id && document.querySelector('label[for="' + this.selectElement.id + '"]')) {
            document.querySelector('label[for="' + this.selectElement.id + '"]').onclick = () => {
                this.element.querySelector('.dynamic-select-header').classList.toggle('dynamic-select-header-active');
            };
        }
        document.addEventListener('click', event => {
            if (!event.target.closest('.' + this.name) && !event.target.closest('label[for="' + this.selectElement.id + '"]')) {
                this.element.querySelector('.dynamic-select-header').classList.remove('dynamic-select-header-active');
            }
        });
    }

    _updateSelected() {
        // Asegúrate de que el header muestre siempre el initialSelectedHTML al inicio
        if (this.initialSelectedHTML) {
            this.element.querySelector('.dynamic-select-header').innerHTML = this.initialSelectedHTML;
            this.element.querySelector('input').value = this.initialSelectedValue; // Asegura que el input hidden tenga el valor correcto
        } else if (this.selectedValue) {
            this.element.querySelector('.dynamic-select-header').innerHTML = this.element.querySelector('.dynamic-select-selected').innerHTML;
        }
    }

    get selectedValue() {
        let selected = this.data.filter(option => option.selected);
        selected = selected.length ? selected[0].value : '';
        return selected;
    }

    set data(value) {
        this.options.data = value;
    }

    get data() {
        return this.options.data;
    }

    set selectElement(value) {
        this.options.selectElement = value;
    }

    get selectElement() {
        return this.options.selectElement;
    }

    set element(value) {
        this.options.element = value;
    }

    get element() {
        return this.options.element;
    }

    set placeholder(value) {
        this.options.placeholder = value;
    }

    get placeholder() {
        return this.options.placeholder;
    }

    set columns(value) {
        this.options.columns = value;
    }

    get columns() {
        return this.options.columns;
    }

    set name(value) {
        this.options.name = value;
    }

    get name() {
        return this.options.name;
    }

    set width(value) {
        this.options.width = value;
    }

    get width() {
        return this.options.width;
    }

    set height(value) {
        this.options.height = value;
    }

    get height() {
        return this.options.height;
    }

}
document.querySelectorAll('[data-dynamic-select]').forEach(select => new DynamicSelect(select));